import { render, staticRenderFns } from "./getLicenseByOrg.vue?vue&type=template&id=862b2c62&"
import script from "./getLicenseByOrg.vue?vue&type=script&lang=js&"
export * from "./getLicenseByOrg.vue?vue&type=script&lang=js&"
import style0 from "./getLicenseByOrg.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports